import DossierTeamRepositoryInterface, { TeamInterface } from '@/services/Dossier/team/interfaces';
import { AxiosInstance } from 'axios';

export default class DossierTeamRepository implements DossierTeamRepositoryInterface {
  constructor(
    private readonly axios: AxiosInstance,
  ) {
  }

  public async getAllTeams(): Promise<TeamInterface[]> {
    const response = await this.axios.get('/dossier-controller/teams');

    return response.data;
  }

  public async createTeam(managerId: string): Promise<TeamInterface> {
    const response = await this.axios.post('/dossier-controller/teams', { managerId });

    return response.data;
  }
}
